import RsaPlanningPage from "./pages/RsaPlanningPage.vue";
export default {
RsaPlanningPage
};
